import { render } from "./Badges.vue?vue&type=template&id=fd061d06&scoped=true"
import script from "./Badges.vue?vue&type=script&lang=js"
export * from "./Badges.vue?vue&type=script&lang=js"

import "./Badges.vue?vue&type=style&index=0&id=fd061d06&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd061d06"]])

export default __exports__